export enum SupportTypes {
  submitRequest = 'request',
  complaints = 'complaint',
  incidentReport = 'incident',
}
